import { WebPlugin } from '@capacitor/core';
import type { BrightcovePlayerPlugin, AudioPlayerState, AudioNotificationOptions, VideoPlayerState, DownloadStateMediaInfo } from './definitions';
export  class BrightcovePlayerWeb extends WebPlugin implements BrightcovePlayerPlugin {
   async updateBrightcoveAccount(options: {accountId: string;policyKey: string;}): Promise<void>{
      console.log('updateBrightcoveAccount', options);
      return;
    }
   async playVideo(options: {fileId: string;position?: number;local?: boolean;}): Promise<{name: string;duration: number;}>{
    console.log('playVideo', options);
    return { name: '', duration: 0 };
   }
   async setSubtitleLanguage(options: {language: string;}): Promise<void>{
    console.log('setSubtitleLanguage', options);
    return;
   }
    async loadAudio(options: {fileId: string;local?: boolean;}): Promise<{name?: string;duration?: number;}>{
      console.log('loadAudio', options);
      return {};
    }
    async backwardAudio(options: {amount: number;}): Promise<void>{
      console.log('backwardAudio', options);
      return;
    }
    async forwardAudio(options: {amount: number;}): Promise<void>{
      console.log('forwardAudio', options);
      return;
    }
    async seekToAudio(options: {position: number;}): Promise<void>{
      console.log('seekTo', options);
      return;
    }
    async enableAudioLooping(options?: {time: number;}): Promise<void>{
      console.log('enable looping', options);
      return;
    }
    async disableAudioLooping(): Promise<void>{
      console.log('disable looping');
      return;
    }
    async isAudioLooping(): Promise<{value: boolean;}>{
      console.log('is looping');
      return { value: false };
    }
    async stopAudio(): Promise<void>{
      console.log('stopAudio');
      return;
    }
    async pauseAudio(): Promise<void>{
      console.log('pauseAudio');
      return;
    }
    async playAudio(): Promise<void>{
      console.log('playAudio');
      return;
    }
    async getVideoPlayerState(): Promise<VideoPlayerState>{
      console.log('getVideoPlayerState');
      return {};
    }
    async getAudioPlayerState(): Promise<AudioPlayerState>{
      console.log('getAudioPlayerState');
        return {};
    }
    async destroyAudioPlayer(): Promise<void>{
      return;
    }
    async setAudioNotificationOptions(options: AudioNotificationOptions): Promise<void>{
      console.log('Set audio notification options', options);
      return;
    }
    async isMediaAvailableLocally(options: {fileId: string;}): Promise<{value: boolean;}>{
      console.log('Is Media Available Locally', options);
        return { value: false };
    }
   async downloadMedia(options: {fileId: string;}): Promise<void>{
    console.log('Download Media', options);
        return;
   }
   async getDownloadedMediasState(): Promise<{medias: Array<DownloadStateMediaInfo>;}>{
    console.log("get Downloaded medias");
    return { medias: [] };
   }
   async deleteDownloadedMedia(options: {fileId: string;}): Promise<void>{
    console.log("Delete downloaded file", options);
        return;
   }
   async notifyBackButtonPressed(): Promise<void>{
    console.log('Not implemented');
    return;
   }
   async playInternalAudio(options: {file: string;}): Promise<void>{
    console.log('Local internal not implemented ', options);
        return;
   }
   async deleteAllDownloadedMedias(): Promise<void>{
    console.log('Delete all downloaded medias');
   }
  }
